import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue';
import BasicMoviePlayer from 'src/components/lib/MoviePlayer/BasicMoviePlayer/index.vue';
import type { GeoItemsMeta, GIMovieList } from 'src/models/geoItem';
import type { ExtremeMapEssentials } from 'src/models';
import type { MoviePlayerParams } from 'src/models/moviePlayer';

interface Props {
  movieLists: Array<GIMovieList>;
  movieListId: string | null;
  extremeMapEssentials: ExtremeMapEssentials | null;
  parentGeoItemsMeta: GeoItemsMeta;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    movieLists: {},
    movieListId: {},
    extremeMapEssentials: {},
    parentGeoItemsMeta: {}
  },
  emits: ["close", "switch-to-compare-mode"],
  setup(__props: any, { expose: __expose, emit: __emit }) {




const emit = __emit;

const emitCloseEvent = () => {
  emit('close');
};
const emitSwitchToCompareMode = (e: MoviePlayerParams) => {
  emit('switch-to-compare-mode', e);
};
// Topからの制御をそのまま渡すため。
const refMoviePlayerVideo = ref<InstanceType<typeof BasicMoviePlayer>>();
const shortcutKeyAction = (key: string) => {
  if (!refMoviePlayerVideo.value) return;

  refMoviePlayerVideo.value.shortcutKeyAction(key);
};

__expose({ shortcutKeyAction });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BasicMoviePlayer, {
    ref_key: "refMoviePlayerVideo",
    ref: refMoviePlayerVideo,
    "movie-lists": __props.movieLists,
    "movie-list-id": __props.movieListId,
    "extreme-map-essentials": __props.extremeMapEssentials,
    "parent-geo-items-meta": __props.parentGeoItemsMeta,
    onClose: emitCloseEvent,
    onSwitchToCompareMode: emitSwitchToCompareMode
  }, null, 8, ["movie-lists", "movie-list-id", "extreme-map-essentials", "parent-geo-items-meta"]))
}
}

})